import React from 'react';
import classNames from 'classnames/bind';
import styles from './IconArrow.module.scss';

const cx = classNames.bind(styles);

function IconArrow({ text = '자세히보기', size = '', color = '', direction = 'right', className = '', style = null }) {
	let iconClass = 'uiico_arrow';

	if (size !== '') {
		iconClass = color !== '' ? `${iconClass}_${size}${color}` : `${iconClass}_${size}`;
	} else {
		iconClass = color !== '' ? `${iconClass}_${color}` : iconClass;
	}

	return (
		<span
			className={cx('uiico', iconClass, direction, className)}
			style={style}
		>
			{text}
		</span>
	);
}

export default IconArrow;
